/* The training column's card box — `Builder planu sekwencja.dc.html`'s `s.cardSt`, transcribed:
 *
 *   position:relative; flex:1; min-height:0; display:flex; flex-direction:column;
 *   overflow:hidden; border-radius:14px; cursor:grab; background:var(--bg-card);
 *   border:1px solid (target ? var(--text) : var(--border));
 *   box-shadow: target ? 0 0 0 3px <neutral> : var(--shadow-card);
 *   opacity: dragging ? .4 : 1; transform: dragging ? scale(.97) : none;
 *   transition: border-color .18s ease, box-shadow .18s ease, opacity .18s ease, transform .18s ease
 *
 * It is the week's `DayColumn` `.card` with the two branches a cycle column cannot take removed:
 * there is no dashed empty state and no `background` transition between them, because a position in
 * a cycle exists only while a training stands on it.
 *
 * The drag state reaches the box through `:has()` rather than through a prop threaded back up: the
 * session card already sets `data-dragging` and `data-lifted` on its own layer, and the box is its
 * parent. Same construction, same reason, as the week's. */

.card {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  cursor: grab;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);

  /* The mock's own four, property for property. Written as the `transition` SHORTHAND because
   * `transition-duration` is on Stylelint's value allowlist as a single token and a comma list
   * fails it; every value below is still a token. */
  transition:
    border-color var(--dur-fp-fade) var(--ease-default),
    box-shadow var(--dur-fp-fade) var(--ease-default),
    opacity var(--dur-fp-fade) var(--ease-default),
    transform var(--dur-fp-fade) var(--ease-default);
}

/* The drag SOURCE dims and shrinks in place. */
.card:has([data-dragging]) {
  opacity: 0.4;
  transform: scale(0.97);
}

/* The DROP target. Every ink in it is neutral — a `--text` edge and a 3px ring in translucent ink,
 * the mock's own `target ? 'var(--text)' : 'var(--border)'`.
 *
 * `data-target` is set by the drop adapter while the pointer is over the box, and by the pane while
 * a KEYBOARD lift points at this position — so a sighted keyboard user gets the same picture as a
 * sighted pointer user. */
.card[data-target] {
  border-color: var(--text);
  box-shadow: var(--shadow-drop-ring);
}

/* The SELECTED day — the one whose panel is open. It loses to `data-target`, exactly as the week's
 * does, because a drop about to land is the more urgent of the two. */
.card[data-selected] {
  border-color: var(--accent);
  box-shadow: var(--shadow-select-ring);
}

.card[data-target][data-selected] {
  border-color: var(--text);
  box-shadow: var(--shadow-drop-ring);
}
